import React from "react";

import { Button } from "@bared/ui";
import clsx from "clsx";

type ReviewsInlineProps = {
  productGroup: string;
  className?: string;
  onSheetToggle: () => void;
};

const ReviewsInline = ({
  productGroup,
  className,
  onSheetToggle,
}: ReviewsInlineProps) => {
  return (
    <Button variant="plain" className="flex" onClick={onSheetToggle}>
      <span
        className={clsx("ruk_rating_snippet capitalize", className)}
        data-sku={productGroup}
      />
    </Button>
  );
};

export default ReviewsInline;
